
import Vue from 'vue';
import axios from '@/plugins/axios.js';
import { Component, Provide, Prop, Ref } from 'vue-property-decorator';
@Component
export default class InputExpress extends Vue {
    @Prop() private channels!: { [index: string]: string };
    @Provide() private showDialog: boolean = false;
    @Provide() private expressInfo: any = {
        content: '发票',
        channel: '',
        expressNumber: '',
        receiptType: 0,
    };
    @Provide() private rules: { [index: string]: object[] } = {
        channel: [
            { required: true, message: '请选择物流公司', trigger: 'change' },
        ],
        expressNumber: [
            { required: true, message: '请填写快递单号', trigger: 'blur' },
        ],
        receiptType: [
            { required: true, message: '请选择发票类型', trigger: 'change' },
        ],
    };
    @Prop() private selectedInvoice!: any;
    @Ref() private readonly expressForm;

    private created() {
        this.$on('open', () => {
            this.showDialog = true;
        });
    }
    private clearValidate() {
        this.expressForm.clearValidate();
    }

    private submit() {
        this.expressForm.validate((valid) => {
            if (!valid) {
                return false;
            }
            axios.post('/api/v1/invoice-manage/create-express-record', {
                invoiceId: this.selectedInvoice.id,
                ...this.expressInfo,
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '快递信息录入成功',
                });
                this.expressInfo.expressNumber = '';
                this.showDialog = false;
                this.$emit('refreshCreatedInvoices');
            }).catch((error) => {
                this.$message.error(error);
            });
        });
    }
}
